import { ManualInjector } from '../../../../../manual-injector';
import EquipmentInfoService from '../../../../../../components/base/infoServices/EquipmentInfoService';
import _ from 'lodash';
import supportedActions from './supportedSimpleActionsList';
export default class EquipmentSelect {
    async load({ customKey, customDescription, eqTriggerSelectMode, onlyEquipmentWithActions, filterOnProperty }) {
        const equipmentInfoService = ManualInjector.injector.get(EquipmentInfoService);
        const eqs = await equipmentInfoService.getAllEquipments();
        const key = customKey ?? 'equipmentSelect';
        const componentSchema = {
            label: 'Equipment',
            description: customDescription || 'Select Equipment',
            key,
            type: 'select',
            dataSrc: 'custom',
            refreshOn: filterOnProperty,
            clearOnRefresh: true,
            clearOnHidden: true,
            valueProperty: 'value',
            multi: false,
            data: {
                custom: (scope) => _.reduce(eqs, (acc, eq) => {
                    if ((!filterOnProperty || (eq.org === _.get(scope.data, filterOnProperty))) &&
                        (!onlyEquipmentWithActions || supportedActions[eq.equipmentType])) {
                        const eqCopy = _.pick(eq, ['type', 'pattern', 'id', 'name', 'equipmentType', 'org', 'site']);
                        if (eqTriggerSelectMode) { // This is used to filter in StackStorm
                            _.assign(eqCopy, {
                                type: 'equals',
                                pattern: eqCopy.id
                            });
                        }
                        acc.push({ label: eqCopy.name, value: eqCopy });
                    }
                    return acc;
                }, [])
            },
            customOptions: {
                searchResultLimit: 10,
            }
        };
        return componentSchema;
    }
}
